import CourseList from './CourseList.vue'

export default CourseList



// WEBPACK FOOTER //
// ./client/masteradmin/pages/CourseList/index.js